"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultUIConfiguration = exports.StreamingPlayerPageLayoutPosition = void 0;
const common_model_1 = require("./common.model");
var StreamingPlayerPageLayoutPosition;
(function (StreamingPlayerPageLayoutPosition) {
    StreamingPlayerPageLayoutPosition["START"] = "start";
    StreamingPlayerPageLayoutPosition["CENTER"] = "center";
    StreamingPlayerPageLayoutPosition["END"] = "end";
    StreamingPlayerPageLayoutPosition["HIDDEN"] = "hidden";
})(StreamingPlayerPageLayoutPosition = exports.StreamingPlayerPageLayoutPosition || (exports.StreamingPlayerPageLayoutPosition = {}));
const defaultTypography = {
    fontSize: '16px',
    fontFamily: common_model_1.StreamingPlayerStylesFontFamily.ROBOTO,
    fontWeight: '400',
    color: '#222',
};
const emptyTypography = {
    fontSize: '',
    fontFamily: '',
    fontWeight: '',
    color: '',
};
const emptyBackground = {
    color: '',
    image: {
        url: '',
        alt: '',
        blur: '0px',
        position: 'center',
        fit: 'cover',
    },
};
exports.defaultUIConfiguration = {
    page: {
        enabled: true,
        layout: common_model_1.StreamingPlayerPageLayout.THREE_ROWS,
        typography: defaultTypography,
        background: emptyBackground,
        features: {
            autoplay: true,
            spotify: true,
            description: false,
            download: false,
            notes: false,
            tracklist: false,
            analytics: false,
        },
        sections: {
            header: {
                typography: emptyTypography,
                background: emptyBackground,
            },
            footer: {
                typography: Object.assign(Object.assign({}, emptyTypography), { fontSize: '12px' }),
                background: emptyBackground,
            },
            primary: {
                typography: emptyTypography,
                background: emptyBackground,
            },
            secondary: {
                typography: emptyTypography,
                background: Object.assign(Object.assign({}, emptyBackground), { color: '#f7f7f7' }),
            },
        },
        title: {
            content: 'HearDis!',
            typography: Object.assign(Object.assign({}, emptyTypography), { fontSize: '30px' }),
            position: StreamingPlayerPageLayoutPosition.HIDDEN,
        },
        description: {
            content: '<h1 class="ql-align-justify">Lorem ipsum dolor sit amet</h1><p class="ql-align-justify">consectetur adipiscing elit. Sed mollis erat ligula, sit amet placerat ex pulvinar non. Cras et vehicula elit, vel malesuada sem. Ut luctus commodo enim, a vehicula lectus varius nec. </p><ol><li class="ql-align-justify">Interdum et malesuada fames ac ante ipsum primis in faucibus. </li><li class="ql-align-justify">Maecenas facilisis odio ac quam porta aliquam. </li><li class="ql-align-justify">Maecenas tempus mattis nisl at molestie. </li></ol><p class="ql-align-justify"><br></p><p class="ql-align-justify"><strong>Curabitur pharetra mauris</strong> <u>scelerisque urna accumsan</u>. <em>Fusce arcu urna</em>, consequat id aliquet in, egestas in nunc. Donec non ante ut nunc rhoncus imperdiet. Quisque ut ultrices ligula, ac finibus sapien. Quisque tincidunt dui sed ex dictum, vel tristique purus commodo.</p><p><br></p>',
            typography: emptyTypography,
        },
        logo: {
            image: {
                url: 'assets/logo.svg',
                alt: 'HearDis! logo',
                blur: '0px',
                fit: 'contain',
                position: 'center',
            },
            position: StreamingPlayerPageLayoutPosition.CENTER,
            size: '50px',
        },
        seo: {
            title: '',
            description: '',
            image: '',
        },
        player: {
            typography: emptyTypography,
            background: emptyBackground,
            elementsColor: '#222',
            artwork: {
                enabled: true,
                alwaysDefault: false,
                defaultImage: {
                    url: 'assets/artwork.png',
                    alt: '',
                    blur: '0px',
                    position: 'center',
                    fit: 'cover',
                },
            },
        },
    },
    widget: {
        enabled: false,
        features: {
            autoplay: true,
            spotify: true,
            description: false,
            download: false,
            notes: false,
            tracklist: false,
            analytics: false, // user needs to explicitly activate it after configuring the measurementId
        },
        typography: defaultTypography,
        background: emptyBackground,
        player: {
            typography: emptyTypography,
            background: emptyBackground,
            elementsColor: '#222',
            artwork: {
                enabled: true,
                alwaysDefault: false,
                defaultImage: {
                    url: 'assets/artwork.png',
                    alt: '',
                    blur: '0px',
                    position: 'center',
                    fit: 'cover',
                },
            },
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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